import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Eye, EyeOff } from "lucide-react";
import { Logo } from "../components/Logo";
type AuthProps = {
  setUserName: (name: string) => void;
};
const Auth = ({ setUserName }: AuthProps) => {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState<{ email?: string; password?: string }>({});
  const navigate = useNavigate();

  const validateForm = () => {
    const newErrors: { email?: string; password?: string } = {};
    if (!email.includes("@")) newErrors.email = "Please enter a valid email";
    if (password.length < 6) newErrors.password = "Password must be at least 6 characters";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) return;
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      const name = email.split("@")[0];

localStorage.setItem("userName", name); // ✅ تخزين
setUserName(name);   
      alert(`${isLogin ? "Signed in" : "Account created"} with ${email}`);
      navigate("/dashboard"); // ترجعي للصفحة الرئيسية
    }, 1000);
  };

  return (
    <div className="min-h-screen flex">
      {/* Left Section - Promotional */}
      <div className="hidden lg:flex lg:w-1/3 bg-gradient-to-br from-purple-100 to-purple-50 relative overflow-hidden authLeftSide">
        <div className="flex flex-col justify-center items-center w-full p-12 relative z-10">
          <div className="text-start space-y-4">
            <h1 className="text-4xl font-bold text-gray-800 authHead">Structured QA.</h1>
            <h1 className="text-4xl  text-gray-800 authP">Intelligent execution.</h1>
          </div>
        </div>
        {/* Decorative Pattern */}
        <div className="absolute bottom-0 left-0 w-full h-[240px] ">
        <svg xmlns="http://www.w3.org/2000/svg" width="275" height="274" viewBox="0 0 275 274" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M-67.9072 212.096C-49.3754 193.564 -24.9364 184.541 -0.651352 185.023C0.267143 207.408 9.27193 229.524 26.3633 246.615C43.9551 264.207 66.8697 273.23 89.9229 273.688C90.946 298.616 81.9428 323.879 62.9102 342.912C26.7861 379.036 -31.7832 379.036 -67.9072 342.912C-104.031 306.788 -104.031 248.22 -67.9072 212.096ZM184.191 185.02C207.299 185.439 230.28 194.463 247.913 212.096C284.037 248.22 284.037 306.788 247.913 342.912C211.789 379.036 153.221 379.036 117.097 342.912C98.0645 323.88 89.0598 298.618 90.082 273.691C114.315 274.131 138.688 265.107 157.18 246.615C174.272 229.523 183.274 207.406 184.191 185.02ZM90.0811 88.7219C89.0683 113.639 98.0731 138.887 117.097 157.91C135.588 176.402 159.961 185.425 184.193 184.986C184.193 184.997 184.192 185.008 184.191 185.02C159.959 184.581 135.588 193.605 117.097 212.096C100.005 229.188 91.0001 251.304 90.082 273.691C90.029 273.69 89.9759 273.689 89.9229 273.688C89.0042 251.302 80.0012 229.187 62.9102 212.096C45.318 194.504 22.4024 185.48 -0.651352 185.023C-0.651901 185.009 -0.651787 184.996 -0.652328 184.983C22.4017 184.525 45.3177 175.503 62.9102 157.91C81.9332 138.887 90.936 113.64 89.9238 88.7238C89.9762 88.7228 90.0287 88.7228 90.0811 88.7219ZM-67.9072 27.093C-31.7832 -9.03098 26.7861 -9.03101 62.9102 27.093C80.0111 44.194 89.0139 66.3253 89.9238 88.7238C66.8703 89.1815 43.9554 98.2069 26.3633 115.799C7.34089 134.822 -1.66388 160.067 -0.652328 184.983C-24.9371 185.464 -49.3756 176.442 -67.9072 157.91C-104.031 121.786 -104.031 63.217 -67.9072 27.093ZM117.097 27.093C153.221 -9.03058 211.789 -9.03076 247.913 27.093C284.037 63.217 284.037 121.786 247.913 157.91C230.281 175.543 207.3 184.566 184.193 184.986C185.206 160.069 176.203 134.822 157.18 115.799C138.688 97.3071 114.314 88.2817 90.0811 88.7219C90.9914 66.324 99.9962 44.1935 117.097 27.093Z" fill="url(#paint0_linear_6_724)" fill-opacity="0.14"/>
<defs>
<linearGradient id="paint0_linear_6_724" x1="90.0029" y1="0" x2="90.0029" y2="370.005" gradientUnits="userSpaceOnUse">
<stop stop-color="#0D12FF"/>
<stop offset="1" stop-color="#080B99"/>
</linearGradient>
</defs>
</svg>
        </div>
      </div>

      {/* Right Section - Login Form */}
      <div className="w-full lg:w-2/3 bg-white flex items-center justify-center p-8 relative">
        <div className="w-full max-w-md ">
          {/* Logo */}
          <div className="mb-8 authLogo">
            <Logo showText={true} />
          </div>

          {/* Heading */}
          <h2 className="text-3xl font-bold mb-2 authHead2">
            Log in to your account
          </h2>
          <p className=" mb-8 authP2">
            Welcome Back, Login with email id and password
          </p>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <div className="relative">
                <img 
                  src="/mail.svg" 
                  alt="email icon" 
                  className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5" 
                />
                <input
                  id="email"
                  type="email"
                  placeholder="Email id"
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); if (errors.email) setErrors({ ...errors, email: undefined }); }}
                  className={`authInput w-full pl-10 pr-3 py-3 bg-gray-100 border border-gray-200 rounded-lg text-gray-600 placeholder-gray-400 focus:outline-none focus:bg-white focus:border-gray-300 transition-colors ${
                    errors.email ? "border-red-500 bg-red-50" : ""
                  }`}
                  disabled={isLoading}
                />
              </div>
              {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
            </div>

            <div className="space-y-2">
              <div className="relative">
                <img 
                  src="/pass.svg" 
                  alt="password icon" 
                  className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5" 
                />
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => { setPassword(e.target.value); if (errors.password) setErrors({ ...errors, password: undefined }); }}
                  className={`authInput w-full pl-10 pr-10 py-3 bg-gray-100 border border-gray-200 rounded-lg text-gray-600 placeholder-gray-400 focus:outline-none focus:bg-white focus:border-gray-300 transition-colors ${
                    errors.password ? "border-red-500 bg-red-50" : ""
                  }`}
                  disabled={isLoading}
                />
                <button 
                  type="button" 
                  onClick={() => setShowPassword(!showPassword)} 
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                >
                  {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
              </div>
              {errors.password && <p className="text-red-500 text-sm mt-1">{errors.password}</p>}
            </div>

            <button 
              type="submit" 
              disabled={isLoading} 
              className="authButton w-full py-3 px-4 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading && <Loader2 className="w-5 h-5 mr-2 animate-spin" />}
              {isLogin ? "Login" : "Create Account"}
            </button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-gray-600 text-sm">
              {isLogin ? "Don't have an account?" : "Already have an account?"}{" "}
              <button 
                onClick={() => { setIsLogin(!isLogin); setErrors({}); }} 
                className="text-blue-500 hover:text-blue-600 font-medium"
              >
                {isLogin ? "Sign up" : "Sign in"}
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Auth;
